import React from 'react';
import { Cards } from '../Cards/Cards';
import './CardsProyects.css';
import { labusolutions, cophi, inmo, fooddesk, stock, taketurn } from '../../../assets/works';

export const CardsProyects = () => {
  const data = [
    {
      nombre: 'Food-Desk',
      description:
        'Food Desk es una plataforma web orientada al sector gastronómico que permite a restaurantes digitalizar su carta y gestionar pedidos mediante un sistema de menú online accesible desde dispositivos móviles. La solución busca optimizar la experiencia del cliente y mejorar la eficiencia operativa del negocio.',
      img: [fooddesk],
      skills: ['#React.js', '#Firebase', '#Javascript', '#Tailwind', '#Node.js'],
      LinkUrl: 'https://fooddesk.com.ar/',
    },
    {
      nombre: 'Take-Turn',
      description:
        'Plataforma web desarrollada con React y Firebase Cloud Functions para gestión de procesos internos y operaciones, con enfoque en velocidad de carga y una experiencia clara para el equipo operativo.',
      img: [taketurn],
      skills: ['#React.js', '#Firebase', '#SAP', '#CloudFunctions'],
      LinkUrl: 'https://taketurn-246cd.web.app/',
    },
    {
      nombre: 'Stockeate',
      description:
        'Plataforma web desarrollada con React y Firebase Cloud Functions, integrada con SAP para gestionar órdenes de compra y usuarios. Permite crear, enviar y autorizar órdenes directamente desde el portal.',
      img: [stock],
      skills: ['#React.js', '#Firebase', '#Operations', '#RealTime'],
      LinkUrl: 'https://stockeate-238f4.web.app/',
    },
    {
      nombre: 'Cophi Web-App',
      description:
        'Aplicación web con arquitectura modular para digitalizar procesos comerciales y administrativos, con integraciones cloud orientadas a mejorar la trazabilidad y el control diario.',
      img: [cophi],
      skills: ['#React.js', '#Firebase', '#Modular', '#Cloud'],
      LinkUrl: 'https://cophi.com.ar/',
    },
    {
      nombre: 'Labu.Solutions',
      description:
        'Solución web para gestión de operaciones y automatización de flujos de trabajo, con foco en mantenimiento simple, rendimiento estable y escalabilidad para nuevos módulos.',
      img: [labusolutions],
      skills: ['#React.js', '#Firebase', '#Automation', '#Workflow'],
      LinkUrl: 'https://labu-solution.vercel.app/',
    },
    {
      nombre: 'Aires del Virrey - Inmobiliaria',
      description:
        'Sitio web orientado al rubro inmobiliario para exhibición de propiedades y gestión de consultas, priorizando claridad visual, navegación simple y versión responsive.',
      img: [inmo],
      skills: ['#React.js', '#Firebase', '#Responsive', '#Design'],
     // Guessing URL or leaving as is if not available
    },
  ];

  return (
    <section className='container-cardproject' id='projects'>
      <div className='container-cardproject-title'>
        <p className='subtitle'>Destacados</p>
        <h2>Mis Proyectos</h2>
        <p className='description'>
          Selección de productos digitales donde participé como desarrollador y líder técnico.
        </p>
      </div>

      <div className='projects-grid'>
        {data.map((project) => (
          <Cards
            key={project.nombre}
            work={project.nombre}
            description={project.description}
            img={project.img}
            skills={project.skills}
            linkUrl={project.LinkUrl}
          />
        ))}
      </div>
    </section>
  );
};
